<template>
	<div>
		<div class="row">
			<div class="col-md-6">
				<div class="select-institute">
					<span>{{ $t("instituteName") }}</span>
					<select
						class="form-select"
						aria-label="Institute"
						v-model="currentIns"
					>
						<option
							v-bind:key="ins.id"
							v-for="ins in institutes"
							v-bind:value="ins.id"
							>{{ ins.name }}</option
						>
					</select>
				</div>
			</div>
			<div class="col-md-6 d-flex justify-content-end">
				<button class="add-course my-5" @click="addCourse">
					{{ $t("addNew") }}
				</button>
			</div>
		</div>

		<div class="table-responsive">
			<table id="coursesTable" class="display">
				<thead>
					<tr>
						<th>{{ $t("tables.courseCode") }}</th>
						<th>{{ $t("tables.name") }}</th>
						<th>{{ $t("tables.description") }}</th>
						<th>{{ $t("tables.type") }}</th>
						<th class="no-sort">
							{{ $t("tables.actions") }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="addCourseField" class="addCourseRow">
						<td>
							<input
								v-model="newCourse.course_code"
								class="form-control"
								type="text"
								placeholder="Course Code"
							/>
						</td>
						<td>
							<input
								v-model="newCourse.title"
								class="form-control"
								type="text"
								placeholder="Course Name"
							/>
						</td>
						<td>
							<textarea
								maxlength="750"
								v-model="newCourse.description"
								class="form-control"
								type="text"
								placeholder="Course Description"
							></textarea>
						</td>
						<td>
							<select
								class="form-select"
								aria-label="Default select example"
								v-model="newCourse.course_type"
							>
								<option selected value="null">Open this select menu</option>
								<option
									v-bind:key="courseType.course_type_id"
									v-for="courseType in courseTypes"
									v-bind:value="courseType.course_type_id"
									>{{ courseType.course_type_name }}</option
								>
							</select>
						</td>
						<td>
							<button class="mr-2" v-on:click="saveCourse">
								Save
							</button>
							<button class="delete-btn" v-on:click="cancelAddingCourse">
								Cancel
							</button>
						</td>
					</tr>
					<tr v-for="(course, index) in courses" v-bind:key="index">
						<td>{{ course.course_code }}</td>
						<td>{{ course.title }}</td>
						<td v-bind:title="course.description">
							{{
								course.description && course.description.length > 50
									? `${course.description.substring(0, 50)}...`
									: course.description
							}}
						</td>
						<td>
							{{ course.course_type_name }}
						</td>
						<td class="actions">
							<button class="mr-2">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16"
									height="16"
									fill="currentColor"
									class="bi bi-person-lines-fill"
									viewBox="0 0 16 16"
								>
									<path
										d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"
									/>
								</svg>
							</button>
							<button
								class="delete-btn"
								v-if="editCourse === null"
								v-on:click="deleteCourse(course)"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16"
									height="16"
									fill="currentColor"
									class="bi bi-trash-fill"
									viewBox="0 0 16 16"
								>
									<path
										d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
									/>
								</svg>
							</button>
							<button
								class="ml-2"
								v-if="editCourse === null"
								v-on:click="startEdit(index)"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16"
									height="16"
									fill="currentColor"
									class="bi bi-pencil-square"
									viewBox="0 0 16 16"
								>
									<path
										d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
									/>
									<path
										fill-rule="evenodd"
										d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
									/>
								</svg>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="modal fade" id="courseModal" tabindex="-1" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h1 class="modal-title fs-5" id="exampleModalLabel">
							{{ $t("coursesManagement.courseModal.courseData") }}
						</h1>
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
						></button>
					</div>
					<div class="modal-body">
						<form>
							<div class="mb-3">
								<label for="recipient-name" class="col-form-label"
									>{{ $t("coursesManagement.courseModal.courseCode") }}:</label
								>
								<input
									v-if="editCourse"
									v-model="tempCourseEdit.course_code"
									class="form-control"
									type="text"
									:placeholder="$t('coursesManagement.courseModal.courseCode')"
								/>
								<input
									v-else
									v-model="newCourse.course_code"
									class="form-control"
									type="text"
									:placeholder="$t('coursesManagement.courseModal.courseCode')"
								/>
							</div>
							<div class="mb-3">
								<label for="recipient-name" class="col-form-label"
									>{{ $t("coursesManagement.courseModal.courseName") }}:</label
								>
								<input
									v-if="editCourse"
									v-model="tempCourseEdit.title"
									class="form-control"
									type="text"
									:placeholder="$t('coursesManagement.courseModal.courseName')"
								/>
								<input
									v-else
									v-model="newCourse.title"
									class="form-control"
									type="text"
									:placeholder="$t('coursesManagement.courseModal.courseName')"
								/>
							</div>
							<div class="mb-3">
								<label for="message-text" class="col-form-label"
									>{{
										$t("coursesManagement.courseModal.courseDescription")
									}}:</label
								>
								<textarea
									v-if="editCourse"
									maxlength="750"
									v-model="tempCourseEdit.description"
									class="form-control"
									type="text"
									:placeholder="
										$t('coursesManagement.courseModal.courseDescription')
									"
								></textarea>
								<textarea
									v-else
									maxlength="750"
									v-model="newCourse.description"
									class="form-control"
									type="text"
									placeholder="Course Description"
								></textarea>
							</div>
							<div class="mb-3">
								<label for="recipient-name" class="col-form-label"
									>{{ $t("coursesManagement.courseModal.courseType") }}:</label
								>
								<select
									v-if="editCourse"
									class="form-select"
									aria-label="Default select example"
									v-model="tempCourseEdit.course_type_id"
								>
									<option selected value="null">{{
										$t("coursesManagement.courseModal.chooseCourseType")
									}}</option>
									<option
										v-bind:key="courseType.course_type_id"
										v-for="courseType in courseTypes"
										v-bind:value="courseType.course_type_id"
										>{{ courseType.course_type_name }}</option
									>
								</select>
								<select
									v-else
									class="form-select"
									aria-label="Default select example"
									v-model="newCourse.course_type"
								>
									<option selected value="null">{{
										$t("coursesManagement.courseModal.chooseCourseType")
									}}</option>
									<option
										v-bind:key="courseType.course_type_id"
										v-for="courseType in courseTypes"
										v-bind:value="courseType.course_type_id"
										>{{ courseType.course_type_name }}</option
									>
								</select>
							</div>
						</form>
					</div>
					<div v-if="editCourse" class="modal-footer">
						<button
							type="button"
							class="btn btn-secondary"
							data-bs-dismiss="modal"
							v-on:click="cancelEdit"
						>
							{{ $t("coursesManagement.courseModal.close") }}
						</button>
						<button
							type="button"
							class="btn btn-primary"
							v-on:click="updateCourse"
						>
							{{ $t("coursesManagement.courseModal.save") }}
						</button>
					</div>
					<div v-else class="modal-footer">
						<button
							type="button"
							class="btn btn-secondary"
							data-bs-dismiss="modal"
							v-on:click="cancelAddingCourse"
						>
							{{ $t("coursesManagement.courseModal.close") }}
						</button>
						<button
							type="button"
							class="btn btn-primary"
							v-on:click="saveCourse"
						>
							{{ $t("coursesManagement.courseModal.save") }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";

export default {
	mixins: [GlobalMixin],
	data() {
		return {
			addCourseField: false,
			institutes: [],
			courses: [],
			courseTypes: [],
			currentIns: null,
			newCourse: {
				title: "",
				course_code: "",
				description: "",
				course_type: "",
			},
			editCourse: null,
			tempCourseEdit: null,
		};
	},
	mounted() {
		this.axios
			.get(`${process.env.VUE_APP_APIEndPoint}institutes/`, this.headers)
			.then(ins => {
				this.institutes = ins.data.data;
				let params = new URLSearchParams(window.location.search);
				this.currentIns = params.get("ins")
					? params.get("ins")
					: this.institutes.length > 1
					? 1
					: this.institutes[0].id;
				this.getCourses();
			});
		this.axios
			.get(
				`${process.env.VUE_APP_APIEndPoint}tutor/course_types/`,
				this.headers
			)
			.then(types => {
				this.courseTypes = types.data;
			});
	},
	methods: {
		cancelEdit(index) {
			this.editCourse = null;
			this.courses[index] = { ...this.tempCourseEdit };
		},
		startEdit(index) {
			this.editCourse = this.courses[index].id;
			this.tempCourseEdit = { ...this.courses[index] };
			$("#courseModal").modal("show");
			console.log("temp values saved", this.tempCourseEdit);
		},
		updateCourse(course) {
			this.axios
				.post(`${process.env.VUE_APP_APIEndPoint}tutor/course/update/`, {
					course_code: this.tempCourseEdit.course_code,
					course: this.tempCourseEdit.id,
					title: this.tempCourseEdit.title,
					course_type: this.tempCourseEdit.course_type_id,
					description: this.tempCourseEdit.description,
					institute: this.currentIns,
				})
				.then(res => {
					console.log("edit response", res);
					this.editCourse = null;
					$("#courseModal").modal("hide");
					this.$router.go();
				})
				.catch(error => {
					let errors = "";
					error.response.data.errors.forEach((value, index) => {
						for (error in value) {
							errors += `<li>${value[error]}</li>`;
						}
					});
					Swal.fire({
						icon: "error",
						html: errors,
					});
				});
		},
		deleteCourse(course) {
			Swal.fire({
				title: `${this.$t(
					"coursesManagement.areYouSureYouWantToDeleteTheCourse"
				)} '${course.title}'?`,
				showCancelButton: true,
				confirmButtonText: `${this.$t("coursesManagement.courseModal.yes")}`,
				cancelButtonText: `${this.$t("coursesManagement.courseModal.close")}`,
			}).then(result => {
				if (result.isConfirmed) {
					this.axios
						.post(
							`${process.env.VUE_APP_APIEndPoint}tutor/course/delete/?institute=${this.currentIns}`,
							{
								course: course.id,
								institute: this.currentIns,
							},
							this.headers
						)
						.then(res => {
							console.log("delete response", res);
							Swal.fire({
								icon: "success",
								text: `Course deleted successfully`,
							});
							this.$router.go();
						})
						.catch(error => {
							let errors = "";
							error.response.data.errors.forEach((value, index) => {
								for (error in value) {
									errors += `<li>${value[error]}</li>`;
								}
							});
							Swal.fire({
								icon: "error",
								html: errors,
							});
						});
				}
			});
		},
		cancelAddingCourse() {
			$("#courseModal").modal("hide");
			this.newCourse = {
				title: "",
				course_code: "",
				description: "",
				course_type: "",
			};
		},
		saveCourse() {
			this.newCourse.institute = this.currentIns;
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/course/add/`,
					this.newCourse
				)
				.then(res => {
					console.log("save response", res);
					$("#courseModal").modal("hide");
					this.newCourse = {
						title: "",
						course_code: "",
						description: "",
						course_type: "",
					};
					this.$router.go();
				})
				.catch(error => {
					let errors = "";
					error.response.data.errors.forEach((value, index) => {
						for (error in value) {
							errors += `<li>${value[error]}</li>`;
						}
					});
					Swal.fire({
						icon: "error",
						html: errors,
					});
				});
		},
		addCourse() {
			$("#courseModal").modal("show");
		},
		getCourses() {
			if (this.currentIns) {
				var self = this;
				this.axios
					.post(
						`${process.env.VUE_APP_APIEndPoint}tutor/courses/`,
						{
							institute: this.currentIns,
						},
						this.headers
					)
					.then(courses => {
						console.log("courses response", courses);
						self.courses = courses.data.data.courses;
						$(document).ready(() => {
							setTimeout(() => {
								$("#coursesTable")
									.dataTable()
									.fnDestroy();
								self.datatable = $("#coursesTable").DataTable({
									bLengthChange: false,
									bFilter: false,
									bInfo: false,
									columnDefs: [{ orderable: false, targets: -1 }],
									responsive: true,
									pagingType: "simple",
									language: {
										paginate: {
											next: `<span>Next<span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                  </svg></span>`,
											previous: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                                         <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                       </svg><span>Previous<span>`,
											last: `<span>Last<span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-bar-right" viewBox="0 0 16 16">
                                     <path fill-rule="evenodd" d="M4.146 3.646a.5.5 0 0 0 0 .708L7.793 8l-3.647 3.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708 0zM11.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"/>
                                   </svg>`,
											first: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-bar-left" viewBox="0 0 16 16">
                                      <path fill-rule="evenodd" d="M11.854 3.646a.5.5 0 0 1 0 .708L8.207 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0zM4.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"/>
                                    </svg><span>First<span>`,
										},
									},
								});
							}, 1000);
						});
					});
			}
		},
	},
	watch: {
		currentIns: {
			handler() {
				if (this.currentIns) {
					this.$router.push(`?ins=${this.currentIns}`);
				}
			},
			immediate: true,
		},
	},
};
</script>

<style scoped lang="scss">
.delete-btn {
	background-color: red;
}

.add-course {
	margin-top: 1.7rem;
}

select.form-select {
	width: 60%;
	margin: auto;
	max-width: 222px;
}

h2,
h5,
p {
	color: #9f9f9f;
}

table.dataTable {
	border-bottom: none !important;

	thead {
		th {
			text-align: center;
			color: #9f9f9f;
			font-weight: bold;
			border-bottom: 1px solid var(--auth-second-color);
			border-right: 1px solid var(--auth-second-color);
			padding-right: 20px !important;

			&:last-child {
				border-right: none;
			}
		}
	}

	tbody {
		tr {
			background-color: transparent;
			box-shadow: none;

			td {
				text-align: start;
				color: #9f9f9f;
				font-weight: normal;
				background-color: transparent;
				box-shadow: none !important;
				border-bottom: 1px solid var(--auth-second-color);
				border-right: 1px solid var(--auth-second-color);

				&:last-child {
					border-right: none;
				}
			}

			&:last-child {
				td {
					border-bottom: none;
				}
			}

			&:hover {
				background-color: lightgray;

				td {
					color: black;
				}
			}
		}
	}
}

button {
	background-color: var(--auth-second-color);
	color: white;
	padding: 5px 10px;
	border-radius: 20px;
}

.filters-container {
	color: #9f9f9f;
	font-size: 12px;

	.filter-criteria {
		display: inline-flex;
		margin-right: 15px;

		.option {
			.form-check {
				padding-left: 5px;
				padding-right: 5px;

				.form-check-label {
					margin-bottom: 0;
					font-weight: normal;
					padding-left: 5px;
					color: var(--auth-second-color);
				}

				.form-check-input {
					float: none;

					&:checked {
						background-color: var(--auth-second-color);
						box-shadow: none;
						border-color: var(--auth-second-color);
					}
				}
			}
		}
	}
}
</style>
<style lang="scss" scoped>
.add-course,
.select-institute {
	text-align: left;
}

.select-institute {
	select.form-select {
		display: inline-block;
		margin: 1.5rem 1.5rem;
	}
}

.dataTables_wrapper .dataTables_paginate {
	margin: auto;
	float: none;
	text-align: center;

	.paginate_button {
		color: #9f9f9f !important;
		border-color: #9f9f9f;
		border-radius: 20px;
		margin: 5px 10px;

		&.current {
			background-color: var(--auth-second-color) !important;
			color: white !important;
		}
	}
}

td.actions {
	min-width: 100px;

	button {
		max-width: 33px;
	}
}

table.dataTable thead > tr > th.sorting:before,
table.dataTable thead > tr > th.sorting:after,
table.dataTable thead > tr > th.sorting_asc:before,
table.dataTable thead > tr > th.sorting_asc:after,
table.dataTable thead > tr > th.sorting_desc:before,
table.dataTable thead > tr > th.sorting_desc:after,
table.dataTable thead > tr > th.sorting_asc_disabled:before,
table.dataTable thead > tr > th.sorting_asc_disabled:after,
table.dataTable thead > tr > th.sorting_desc_disabled:before,
table.dataTable thead > tr > th.sorting_desc_disabled:after,
table.dataTable thead > tr > td.sorting:before,
table.dataTable thead > tr > td.sorting:after,
table.dataTable thead > tr > td.sorting_asc:before,
table.dataTable thead > tr > td.sorting_asc:after,
table.dataTable thead > tr > td.sorting_desc:before,
table.dataTable thead > tr > td.sorting_desc:after,
table.dataTable thead > tr > td.sorting_asc_disabled:before,
table.dataTable thead > tr > td.sorting_asc_disabled:after,
table.dataTable thead > tr > td.sorting_desc_disabled:before,
table.dataTable thead > tr > td.sorting_desc_disabled:after {
	font-size: 1.9em;
	right: 0;
}

table.dataTable tbody tr td:last-child {
	padding: 5px;
	min-width: 125px;
}
</style>
